export const formatInitials = (first?: string, last?: string): string => {
  const nameChar = first?.charAt(0) ?? '';
  const surnameChar = last?.charAt(0) ?? '';

  return `${nameChar}${surnameChar}`.toUpperCase();
};
